export default __webpack_public_path__ + "static/thompson2020-7a46c85a416b90d71af2bd7f2b789dba.png";